import { render, staticRenderFns } from "./MobileChecker.vue?vue&type=template&id=6b4c3abe&"
import script from "./MobileChecker.vue?vue&type=script&lang=ts&"
export * from "./MobileChecker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports